import { render, staticRenderFns } from "./domains-input.vue?vue&type=template&id=4da52116&"
import script from "./domains-input.vue?vue&type=script&lang=js&"
export * from "./domains-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports